import PropTypes from "prop-types";

/** Props passed down from approve / archives pages into thin wrappers → {@link BondEndorsementDialog}. */
export const endorsementDialogParentSharedPropTypes = {
  endorsementDialogOpen: PropTypes.bool.isRequired,
  setEndorsementDialogOpen: PropTypes.func.isRequired,
  isSubmittingEndorsement: PropTypes.bool,
  selectedBondToEndorse: PropTypes.object,
  endorsementType: PropTypes.string,
  setEndorsementType: PropTypes.func,
  counties: PropTypes.array,
  loadingCounties: PropTypes.bool,
  endorsementToCounty: PropTypes.string,
  setEndorsementToCounty: PropTypes.func,
  updatedName: PropTypes.string,
  setUpdatedName: PropTypes.func,
  dwbFirstName: PropTypes.string,
  setDwbFirstName: PropTypes.func,
  dwbMiddleName: PropTypes.string,
  setDwbMiddleName: PropTypes.func,
  dwbLastName: PropTypes.string,
  setDwbLastName: PropTypes.func,
  dwbSuffix: PropTypes.string,
  setDwbSuffix: PropTypes.func,
  dwbAlias: PropTypes.string,
  setDwbAlias: PropTypes.func,
  newBondAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setNewBondAmount: PropTypes.func,
  estimatedAssets: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setEstimatedAssets: PropTypes.func,
  endorsementFile: PropTypes.object,
  setEndorsementFile: PropTypes.func,
  contactName: PropTypes.string,
  setContactName: PropTypes.func,
  contactEmail: PropTypes.string,
  setContactEmail: PropTypes.func,
  role: PropTypes.string,
  getEndorsementInstructions: PropTypes.func,
};

export const approveBondsEndorsementDialogPropTypes = {
  ...endorsementDialogParentSharedPropTypes,
  setIsSubmittingEndorsement: PropTypes.func,
  refreshData: PropTypes.func.isRequired,
};

export const bondArchivesEndorsementDialogPropTypes = {
  ...endorsementDialogParentSharedPropTypes,
  handleEndorsementSupportingFileChange: PropTypes.func,
  handleReleaseRider: PropTypes.func.isRequired,
  handleSubmitEndorsementRequest: PropTypes.func.isRequired,
};

export const bondEndorsementDialogPropTypes = {
  variant: PropTypes.oneOf(["lawFirm", "archives", "approve"]),
  open: PropTypes.bool,
  onClose: PropTypes.func,
  endorsementDialogOpen: PropTypes.bool,
  setEndorsementDialogOpen: PropTypes.func,
  selectedBondToEndorse: PropTypes.object,
  endorsementType: PropTypes.string.isRequired,
  setEndorsementType: PropTypes.func.isRequired,
  newBondAmount: PropTypes.string.isRequired,
  setNewBondAmount: PropTypes.func.isRequired,
  endorsementFile: PropTypes.object,
  setEndorsementFile: PropTypes.func,
  isSubmittingEndorsement: PropTypes.bool.isRequired,
  contactName: PropTypes.string.isRequired,
  setContactName: PropTypes.func.isRequired,
  contactEmail: PropTypes.string.isRequired,
  setContactEmail: PropTypes.func.isRequired,
  updatedName: PropTypes.string.isRequired,
  setUpdatedName: PropTypes.func.isRequired,
  counties: PropTypes.array.isRequired,
  endorsementToCounty: PropTypes.string.isRequired,
  setEndorsementToCounty: PropTypes.func.isRequired,
  loadingCounties: PropTypes.bool.isRequired,
  estimatedAssets: PropTypes.string.isRequired,
  setEstimatedAssets: PropTypes.func.isRequired,
  dwbFirstName: PropTypes.string.isRequired,
  setDwbFirstName: PropTypes.func.isRequired,
  dwbMiddleName: PropTypes.string.isRequired,
  setDwbMiddleName: PropTypes.func.isRequired,
  dwbLastName: PropTypes.string.isRequired,
  setDwbLastName: PropTypes.func.isRequired,
  dwbSuffix: PropTypes.string.isRequired,
  setDwbSuffix: PropTypes.func.isRequired,
  dwbAlias: PropTypes.string.isRequired,
  setDwbAlias: PropTypes.func.isRequired,
  role: PropTypes.string,
  nameChangeOk: PropTypes.bool,
  internalReleaseDisabled: PropTypes.bool,
  lawFirmEndorseSubmitDisabled: PropTypes.bool,
  onReleaseRider: PropTypes.func,
  onSubmitEndorsement: PropTypes.func,
  handleReleaseRider: PropTypes.func,
  handleSubmitEndorsementRequest: PropTypes.func,
  handleEndorsementSupportingFileChange: PropTypes.func,
  getEndorsementInstructions: PropTypes.func,
};
